// extracted by mini-css-extract-plugin
export default {"dashboardSection":"MainLayout_dashboardSection__2hKCd"};